import { useMutation } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useGetDocumentMutation = () => {
  const { loggedIn, securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setDisabled, setProgress } = useActions()

  const getDocument = async (file) => {
    const fetchFn = loggedIn ? securedFetch : fetch
    const url = encodeURI(
      `${loggedIn ? env.apiUrl : env.publicApiUrl}/documents/${file.id}`
    )
    const response = await fetchFn(url)
    await handleResponse(response)
    const reader = response.body.getReader()
    let receivedLength = 0
    const chunks = []
    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        break
      }
      chunks.push(value)
      receivedLength += value.length
      setProgress((100 * receivedLength) / file.size)
    }
    return new Blob(chunks, { type: file.contentType })
  }

  return useMutation({
    mutationFn: ({ file }) => getDocument(file),
    onMutate: () => {
      setDisabled(true)
    },
    onError: (error) => handleError(error, 'Error downloading document'),
    onSettled: () => {
      setProgress(100)
      setDisabled(false)
    }
  })
}

export { useGetDocumentMutation }
